import {checkCort, thumbnailRules, checkCortPoint} from "@/js/regular";

//创建PDF验证规则
const uploadPDFRules = {
  fileName: [{ required: true, message: '请输入文件名', trigger: 'blur' }],
  toUserName: [{ required: true, message: '请输入受邀请人', trigger: 'blur' }],
  year: [{ required: true, message: '请输入(授付日期)年', trigger: 'blur' }],
  moth: [{ required: true, message: '请输入(授付日期)月', trigger: 'blur' }],
  day: [{ required: true, message: '请输入(授付日期)日', trigger: 'blur' }],
  courtDate: [{ required: true, message: '请输入打球日期', trigger: 'blur' }],
  courtTime: [{ required: true, message: '请输入打球时间', trigger: 'blur' }],
  playDay: [{ required: true, message: '请输入比赛日期', trigger: 'blur' }],
  startTime: [{ required: true, message: '请输入开始时间', trigger: 'blur' }],
  threeCart: [{ required: true, message: '请输入三人组的卡车费用', trigger: 'blur' }],
  groupPerson: [{ required: true, message: '请输入组数', trigger: 'blur' }],
  seeingCar: [{ required: true, message: '请输入Seeing off car', trigger: 'blur' }],
  personNum: [{ required: true, message: '请输入人数', trigger: 'blur' }],
  price: [{ required: true, message: '请输入每人/费用', trigger: 'blur' }],
  letterAcceptance: [{ required: true, message: '请输入领取书', trigger: 'blur' }],
  rounds: [{ required: true, message: '请输入回合数', trigger: 'blur' }],
  payGroupsPerson: [{ required: true, message: '请输入比赛组数', trigger: 'blur' }],
  total: [{ required: true, message: '请输入总计费用', trigger: 'blur' }]
}

//菜单验证规则
const menuRules = {
  name: [{ required: true, message: '内容不能为空', trigger: 'blur' }],
  icon: [{ required: true, message: '内容不能为空', trigger: 'blur' }],
  component: [{ required: true, message: '内容不能为空', trigger: 'blur' }],
  router: [{ required: true, message: '路由地址不能为空', trigger: 'blur' }],
  level: [
    { required: true, message: '路由地址不能为空/必须是数字', trigger: 'blur' },
    { validator: checkCort, trigger: 'blur' }
  ],
  sort: [
    { required: true, message: '排序不能为空/必须是数字', trigger: 'blur' },
    { validator: checkCort, trigger: 'blur' }
  ],
  enumDefault: [{ required: true, message: '默认菜单不能为空', trigger: 'blur' }]
}

//字典验证规则
const dictRules = {
  name: [{ required: true, message: '字典名称不能为空', trigger: 'blur' }],
  describe: [{ required: true, message: '关键字不能为空', trigger: 'blur' }],
  keyword: [{ required: true, message: '备注不能为空', trigger: 'blur' }],
  value: [{ required: true, message: '内容不能为空', trigger: 'blur' }]
}

//轮播图验证规则
const bannerRules = {
  name: [{required: true, message: "名称不能为空", trigger: "blur"}],
  md5: [{required: true, message: "图片不能为空", trigger: "blur"}],
  path: [{required: true, message: "跳转路径不能为空", trigger: "blur"}],
  sort: [{required: true, message: "排序不能为空", trigger: "blur"}],
  enumEnable: [{required: true, message: "请选择是否启用", trigger: "blur"}],
  enumType: [{required: true, message: "请选择banner类型", trigger: "blur"}],
}

//标签验证规则
const labelRules = {
  name: [{required: true, message: "名称不能为空", trigger: "blur"}],
  url: [{required: true, message: "跳转路径不能为空", trigger: "blur"}],
  icon: [{required: true, message: "图标不能为空", trigger: "blur"}],
  sort: [{required: true, message: "排序不能为空", trigger: "blur"}],
  enumEnable: [{required: true, message: "是否启用不能为空", trigger: "blur"}],
}

//文章规则
const articleRules = {
  title: [{ required: true, message: '标题不能为空', trigger: 'blur' }],
  enumEnable: [{ required: true, message: '是否启用不能为空', trigger: 'change' }],
  enumAttribute: [{ required: true, message: '属性不能为空', trigger: 'change' }],
  choose: [{ required: true, message: '上传方式不能为空', trigger: 'change' }],
  index: [{ required: true, message: '是否首页显示不能为空', trigger: 'change' }],
  top: [{ required: true, message: '是否顶置不能为空', trigger: 'change' }],
  thumbnail: [{ required: true, validator: thumbnailRules, trigger: 'change' }],
  goodsId: [{ required: true, trigger: 'change' }],
  sort: [
    { required: true, message: '排序不能为空', trigger: 'blur' }/*,
    { min: 1, max: 2, message: '最长不得超过两位数', trigger: 'blur' }*/
  ]
}

// 用户规则
const userRules = {
  username: [{ required: true, message: '账号不能为空', trigger: 'blur' }],
  password: [{ required: true, message: '密码不能为空', trigger: 'blur' }],
  name: [{ required: true, message: '用户名字不能为空', trigger: 'blur' }],
  photo: [{ required: true, message: '头像不能为空', trigger: 'blur' }],
  sex: [{ required: true, message: '性别不能为空', trigger: 'blur' }],
  phone: [{ required: true, message: '电话不能为空', trigger: 'blur' }],
  address: [{ required: true, message: '地址不能为空', trigger: 'blur' }],
  enumStatus: [{ required: true, message: '状态不能为空', trigger: 'blur' }],
  enumType: [{ required: true, message: '用户类型不能为空', trigger: 'blur' }],
  email: [{ required: true, message: '用户邮箱不能为空', trigger: 'blur' }],
  vip: [{ required: true, message: '请选择是否是会员', trigger: 'blur' }],
  roleIds: [{ required: true, message: '请选择角色', trigger: 'blur' }],
  expirationTime: [{ required: true, message: '请选择到期时间', trigger: 'blur' }],
}

//球场规则
const courtRules = {
  name: [{ required: true, message: '球场名称不能为空', trigger: 'blur' }],
  enlishName: [{ required: true, message: '英文名称不能为空', trigger: 'blur' }],
  phone: [{ required: true, message: '手机号不能为空', trigger: 'blur' }],
  year: [{ required: true, message: '开业年份不能为空', trigger: 'blur' }],
  designer: [{ required: true, message: '设计师不能为空', trigger: 'blur' }],
  holesNumber: [{ required: true, message: '孔数不能为空', trigger: 'blur' }],
  enumEnable: [{ required: true, message: '是否启用不能为空', trigger: 'blur' }],
  distance: [{ required: true, message: '路程不能为空', trigger: 'blur' }],
  introduce: [{ required: true, message: '球场介绍不能为空', trigger: 'blur' }],
  index: [{ required: true, message: '请选择是否在首页显示', trigger: 'blur' }],
  sort: [{ required: true, message: '请输入排序', trigger: 'blur' }],
  addr: {
    addr: [{ required: true, message: '请输入地址', trigger: 'blur' }],
    contact: [{ required: true, message: '请输入联系人', trigger: 'blur' }],
    tel: [{ required: true, message: '请输入联系电话', trigger: 'blur' }],
    areaId: [{ required: true, message: '请选择区域', trigger: 'blur' }]
  },
  fee: {
    blueTeePrice: [{ required: true, message: '请输入假期价格', trigger: 'blur' }],
    costPrice: [{ required: true, message: '请输入平时价格', trigger: 'blur' }]
  }
}

//旅行规则
const travelRules = {
  title: [{ required: true, message: '标题不能为空', trigger: 'blur' }],
  price: [{ required: true, message: '价格不能为空', trigger: 'blur' }],
  /*hotel: [{ required: true, message: '酒店名称不能为空', trigger: 'blur' }],*/
  /* houseNumber: [{ required: true, message: '门牌号不能为空', trigger: 'blur' }],*/
  phone: [{ required: true, message: '手机号不能为空', trigger: 'blur' }],
  year: [{ required: true, message: '开业年份不能为空', trigger: 'blur' }],
  holesNumber: [{ required: true, message: '孔数不能为空', trigger: 'blur' }],
  // timetable: [{ required: true, message: '时间表不能为空', trigger: 'blur' }],
  // costDescription: [{ required: true, message: '费用说明不能为空', trigger: 'blur' }],
  remarks: [{ required: true, message: '备注不能为空', trigger: 'blur' }],
  designer: [{ required: true, message: '请输入设计师', trigger: 'blur' }],
  resort: [{ required: true, message: '排序不能为空', trigger: 'blur' }],
  btCourtId: [{ required: true, message: '请选择球场', trigger: 'blur' }],
  court: [{ required: true, message: '球场信息不能为空', trigger: 'blur' }],
  addr: {
    addr: [{ required: true, message: '请输入地址', trigger: 'blur' }],
    areaId: [{ required: true, message: '请选择区域', trigger: 'blur' }]
  }
}

//积分规则
const integralRules = {
  integral: [{ required: true, message: '积分不能为空', trigger: 'blur' }],
  brief: [{ required: true, message: '请填写说明', trigger: 'blur' }],
  enumType: [{ required: true, message: '请选择积分状态', trigger: 'blur' }],
}

//sale规则
const saleRules = {
  refId: [{ required: true, message: '外键关联不能为空', trigger: 'blur' }],
  thumbnail: [{ required: true, message: '缩略图不能为空', trigger: 'blur' }],
  carousel: [{ required: true, message: '轮播图不能为空', trigger: 'blur' }],
  name: [{ required: true, message: '名称不能为空', trigger: 'blur' }],
  brief: [{ required: true, message: '说明不能为空', trigger: 'blur' }],
  costBrief: [{ required: true, message: '价格说明不能为空', trigger: 'blur' }],
  cost: [{ required: true, message: '原价不能为空', trigger: 'blur' }],
  price: [{ required: true, message: '现价不能为空', trigger: 'blur' }],
  startTime: [{ required: true, message: '开始时间不能为空', trigger: 'blur' }],
  endTime: [{ required: true, message: '结束时间不能为空', trigger: 'blur' }],
  enumState: [{ required: true, message: '状态不能为空', trigger: 'blur' }],
  enumType: [{ required: true, message: '优惠包类型不能为空', trigger: 'blur' }],
}

//定制商品规则
const customGoodsRules = {
  name: [{ required: true, message: '定制商品名称不能为空', trigger: 'blur' }],
  thumbnail: [{ required: true, message: '缩略图不能为空', trigger: 'blur' }],
  carousel: [{ required: true, message: '轮播图不能为空', trigger: 'blur' }],
  brief: [{ required: true, message: '说明不能为空', trigger: 'blur' }]
}

//商品规则
const goodsRules = {
  name: [{ required: true, message: '商品名不能为空', trigger: 'blur' }],
  absort: [{ required: true, message: '请输入相关排序', trigger: 'blur' }],
  resort: [{ required: true, message: '请输入首页排序', trigger: 'blur' }],
  num: [{ required: true, message: '请输入数量', trigger: 'blur' }],
  score: [{ required: true, message: '请输入所需积分', trigger: 'blur' }],
  brandId: [{ required: true, message: '请选择品牌', trigger: 'blur' }],
  classifyId: [{ required: true, message: '请选择分类', trigger: 'blur' }],
}

//广告规则
const advertisRules = {
  enumEnable: [{ required: true, message: '启用停用不能为空', trigger: 'blur' }],
  enumType: [{ required: true, message: '请选择广告类型', trigger: 'blur' }],
  content: [{ required: true, message: '广告内容不能为空!', trigger: 'blur' }]
}

//角色规则
const roleRules = {
  name: [{ required: true, message: '角色名称不能为空', trigger: 'blur' }],
  keyword: [{ required: true, message: '关键不能为空', trigger: 'blur' }],
  describe: [{ required: true, message: '角色名称不能为空', trigger: 'blur' }],
  roles: [{ required: true, message: '权限不能为空', trigger: 'blur' }]
}

//优惠券规则
const couponRules = {
  couponName: [{ required: true, message: '优惠券名称不能为空', trigger: 'blur' }],
  couponPrice: [{ required: true, message: '优惠券面额不能为空', trigger: 'blur' },{ validator: checkCortPoint, trigger: 'blur' }],
  startTime: [{ required: false, message: '开始时间不能为空', trigger: 'blur' }],
  endTime: [{ message: '结束时间不能为空', trigger: 'blur' }],
  couponType: [{ required: true, message: '优惠券类型不能为空', trigger: 'blur' }],
  applicableTarget: [{ required: true, message: '适用对象类型不能为空', trigger: 'blur' }],
  applicableProduct: [{ required: true, message: '适用产品不能为空', trigger: 'blur' }],
  effectiveDay: [{ message: '天数不能为空', trigger: 'blur' }]
}

// 饭店规则
const restaurantRules = {
  restaurantName: [{ required: true, message: '饭店名称不能为空', trigger: 'blur' }],
  restaurantTel: [{ required: true, message: '饭店联系方式不能为空', trigger: 'blur' }],
  restaurantConcat: [{ required: false, message: '联系人不能为空', trigger: 'blur' }],
  restaurantType: [{ required: true, message: '饭店类型不能为空', trigger: 'blur' }],
  introduce: [{ required: false, message: '饭店介绍不能为空', trigger: 'blur' }],
  capita: [{ required: true, message: '人均价格不能为空', trigger: 'blur' },{ validator: checkCortPoint, trigger: 'blur' }],
  sort: [{ required: true, message: '请输入排序', trigger: 'blur' }],
  addr: {
    addr: [{ required: true, message: '请输入地址', trigger: 'blur' }],
    contact: [{ required: true, message: '请输入联系人', trigger: 'blur' }],
    tel: [{ required: true, message: '请输入联系电话', trigger: 'blur' }],
    areaId: [{ required: true, message: '请选择区域', trigger: 'blur' }]
  },
  // specialtyFoods: {
  //   specialtyName: [{ required: true, message: '请输入菜品名称', trigger: 'blur' }],
  //   specialtyPrice: [{ required: true, message: '请输入菜品价格', trigger: 'blur' }],
  //   introduce: [{ required: true, message: '请输入菜品介绍', trigger: 'blur' }],
  // }
}

//sale规则
const raiseRules = {
  name: [{ required: true, message: '名称不能为空', trigger: 'blur' }],
  courtName: [{ required: true, message: '希望球场不能为空', trigger: 'blur' }],
  applyEndDate: [{ required: true, message: '报名结束时间不能为空', trigger: 'blur' }],
  raceDate: [{ required: true, message: '开始时间不能为空', trigger: 'blur' }],
  raceTime: [{ required: true, message: '打球时间起不能为空', trigger: 'blur' }],
  fee: [{ required: true, message: '打球费用不能为空', trigger: 'blur' }],
  joinFee: [{ required: true, message: '参加费用不能为空', trigger: 'blur' }],
  userName: [{ required: true, message: '预约人不能为空', trigger: 'blur' }],
  tel: [{ required: true, message: '电话不能为空', trigger: 'blur' }],
  email: [{ required: true, message: '邮箱不能为空', trigger: 'blur' }],
  num: [{ required: true, message: '组数不能为空', trigger: 'blur' }],
  kickOffMode: [{ required: true, message: '方式不能为空', trigger: 'blur' }],
  sort: [{ required: true, message: '排序不能为空', trigger: 'blur' }],
  carousel: [{ required: true, message: '轮播图不能为空', trigger: 'blur' }],
}


export {
  uploadPDFRules, menuRules,dictRules,bannerRules,labelRules,articleRules,userRules,courtRules,
  travelRules,integralRules,saleRules,customGoodsRules,goodsRules,advertisRules,roleRules,couponRules,
  restaurantRules,raiseRules
}
